import { focusOutline } from "@/common/ui/focus-outline";

import type { AuditLogFilters } from "./use-audit-log";

interface AuditLogToolbarProps {
  filters: AuditLogFilters;
  onFiltersChange: (filters: AuditLogFilters) => void;
  isLoading: boolean;
}

const ACTION_OPTIONS: { label: string; value: string }[] = [
  { label: "All Actions", value: "" },
  { label: "auth.login", value: "auth.login" },
  { label: "session.switch", value: "session.switch" },
  { label: "enterprise.create", value: "enterprise.create" },
  { label: "org.create", value: "org.create" },
  { label: "membership.invite", value: "membership.invite" },
  { label: "membership.accept", value: "membership.accept" },
  { label: "membership.role_update", value: "membership.role_update" },
];

export function AuditLogToolbar({
  filters,
  onFiltersChange,
  isLoading,
}: AuditLogToolbarProps): React.ReactElement {
  return (
    <div data-testid="audit-toolbar" className="flex flex-wrap items-end gap-3">
      <div className="flex flex-col gap-1">
        <label htmlFor="audit-action-filter" className="text-xs font-medium text-muted-foreground">
          Action
        </label>
        <select
          id="audit-action-filter"
          data-testid="audit-filter-action"
          value={filters.action}
          onChange={(e) => onFiltersChange({ ...filters, action: e.target.value })}
          disabled={isLoading}
          className={`flex h-9 w-52 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors ${focusOutline}`}
        >
          {ACTION_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
